export class ScannerService {
  static setScannerId(scannerId: string) {
    localStorage.setItem('scanner_id', scannerId);
  }

  static getScannerId() {
    return localStorage.getItem('scanner_id');
  }
}
